import { Topic } from '~src/interfaces/topic.interface';
import {
  GET_TOPICS_FOR_SURVEY_FAILED,
  GET_TOPICS_FOR_SURVEY_REQUEST,
  GET_TOPICS_FOR_SURVEY_SUCCESS,
} from '~src/modules/surveys/constants/actionTypes';
import { defaultPulseCheckApi } from '~src/services/ApiController';
import { AsyncAction } from '~src/services/apiMiddleware';

interface Question {
  id: string;
  topicId: string;
  title: { [key: string]: string };
  selfTitle?: { [key: string]: string };
  description?: { [key: string]: string };
  framework: boolean;
  comments: string;
  scaleId: string;
  scaleVersionId: string;
  customComments: boolean;
  customScale: boolean;
  subject: string;
  originalTitle: { [key: string]: string };
  originalSelfTitle?: any;
  originalDescription?: any;
  createdAt: string;
  updatedAt: string;
  isCommentEnabled: boolean;
}

export interface TopicsForSurvey {
  id: string;
  name: { [key: string]: string };
  description?: { [key: string]: string };
  subject: string;
  comments: string;
  archived: boolean;
  framework: boolean;
  scaleId: string;
  scaleVersionId: string;
  questions: Question[];
  questionCount: number;
  originalName: { [key: string]: string };
  originalDescription?: any;
  createdAt: string;
  updatedAt: string;
}

export interface FetchTopicsForSurveyParams {
  include: 'questions' | 'questions,private';
}

export const fetchTopicsForSurvey = (
  surveyId: string,
  params: FetchTopicsForSurveyParams,
): AsyncAction<Topic[]> => {
  return {
    types: [GET_TOPICS_FOR_SURVEY_REQUEST, GET_TOPICS_FOR_SURVEY_SUCCESS, GET_TOPICS_FOR_SURVEY_FAILED],
    callAPI: () => defaultPulseCheckApi.getSurveyTopics(surveyId, params),
    payload: { surveyId },
  };
};
